"use client";

import * as React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SwissStyleTextSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section data-section-id="178732" id="twocolumnsection" className="bg-background text-foreground !h-[440px] ![padding:0px_0px_40px_0px]">
      <div ref={ref} className="container mx-auto max-w-6xl transition-all duration-1000 ease-out opacity-100 translate-y-0 !p-0 !h-[430px]">
        <Separator className="bg-border" />
        
        <div className="grid grid-cols-1 gap-12 !h-[430px] lg:grid-cols-12 lg:gap-16">
          <div className="flex flex-col gap-10 !justify-center !items-start lg:col-span-5">
            <h2 className="font-semibold font-default text-primary tracking-tight leading-[1.15] !text-4xl !w-[450px]">En partner som ser helheten</h2>
            <div className="flex flex-col gap-8">
              <p className="text-muted-foreground font-sans leading-relaxed font-normal !text-sm">Vi tar ansvar för hela din ekonomifunktion eller stöttar där det behövs som mest. Du får alltid en personlig kontakt, och vi samarbetar nära med ditt team.</p>
              <p className="text-muted-foreground font-sans leading-relaxed font-normal !text-sm">Vi kallar det ekonomisk överblick – att du känner trygghet i att allt hanteras rätt, att du har rätt underlag i tid, och att vi tillsammans skapar en stabil grund för fortsatt utveckling.</p>
            </div>
          </div>
          
          <div className="lg:col-span-7 lg:col-start-6">
            <img src="https://logikekonomi.se/wp-content/uploads/2026/04/LOGIK-EKONOMI-S.png" alt="Logik Ekonomi professional office space" className="w-full min-h-[400px] object-cover rounded-sm !h-[430px]" />
          </div>
        </div>
      </div>
    </section>;
}